'use client'

import { Suspense } from 'react'
import { usePathname, useSearchParams } from 'next/navigation'
import { FOOTER_NOTE } from '@/lib/naming'

function Note() {
  return (
    <footer className='mt-auto flex justify-end pt-6'>
      <p className='text-right text-xs text-muted-foreground'>{FOOTER_NOTE}</p>
    </footer>
  )
}

/** The command briefing prints the note itself, at the foot of its first screen. */
function FooterWithQuery() {
  const pathname = usePathname()
  const params = useSearchParams()
  if (pathname === '/' && params?.get('view') !== 'full') return null
  return <Note />
}

/**
 * The one line every page carries, bottom right: the figures and the
 * organisations are fictitious. 12px, muted, never hidden. Not on the
 * briefing (`/`), whose hero already prints it; Full detail
 * (`/?view=full`) has no hero note, so the footer shows there.
 */
export function ShellFooter() {
  const pathname = usePathname()
  return (
    <Suspense fallback={pathname === '/' ? null : <Note />}>
      <FooterWithQuery />
    </Suspense>
  )
}
